import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser as userIcon,
  faBriefcase as briefcaseIcon,
} from '@fortawesome/pro-solid-svg-icons';

import './styles.scss';

export default function ContactIcon({ contact }) {
  let content;
  if (contact.initials) {
    content = contact.initials;
  } else {
    const icon = contact.isBusiness ? briefcaseIcon : userIcon;
    content = <FontAwesomeIcon icon={icon} size="lg" />;
  }

  return (
    <span className="backoffice-contact-icon">
      {content}
    </span>
  );
}

ContactIcon.propTypes = {
  contact: PropTypes.shape({
    initials: PropTypes.string,
    isBusiness: PropTypes.bool,
  }).isRequired,
};
